<template>
  <div style="background:white;padding:20px">
    <notion v-for="item in blockMap" :key="item.value.id" :item="item"></notion>
  </div>
</template>

<script>
  import Notion from './Notion'
  export default {
    name: 'Test',
    components: {
      Notion
    },
    props: {
      docType: {
        type: String,
        default: 'product'
      }
    },
    data() {
      return {
        blockMap: [],
        user: '83a2bc3e993e433eb1b904552ff542c1',
        product: '0c0320b5bd6e44b6a68d1d3bd82c12e5'
      }
    },
    created() {
      this.$axios.get(`${this.masterBackendUrl}public/notion/${this.product}`).then(res => {
        let blockMaps = null;
        let blockMap = null;
        if(this.docType === 'user') {
          blockMaps = Object.keys(res.data).map(i => res.data[i]).slice(0, 48);
          blockMap = blockMaps.slice(0, 38);
          blockMap = blockMap.concat(blockMaps.slice(47));
        } else {
          blockMaps = Object.keys(res.data).map(i => res.data[i]);
          blockMap = blockMaps.slice(0, 35);
          blockMap = blockMap.concat(blockMaps.slice(47, 49));
          blockMap = blockMap.concat(blockMaps.slice(51, 53));
        }


        blockMap.forEach(i => {
          i.children = blockMap.filter(j => j.value.parent_id === i.value.id);
          i.value.root = !blockMap.some(j => j.value.id === i.value.parent_id);
        })
        blockMap = blockMap.filter(i => i.value.root);
        this.blockMap = blockMap;
      });
    }
  }
</script>

<style lang="stylus" scoped>
  .page
    width 100%
  .column
    display flex

</style>
